import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { getyears } from "../../Components/Tools";
import { ReactComponent as Check } from '../../Img/icon-check.svg';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import axios from 'axios';
import qs from 'qs';
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';

const Population = (props) =>
{
    const [aff, setAff] = useState(false);
    const [objet, setObjet] = useState(false);
    const [YearsRetro, setYearsRetro] = useState(null);

    const green = '#59B44A';
    const purple = '#6571FE';

    useEffect(() => {
        if (!props.user) {
            props.getUser()
        }
        else {
            /* Récupération des années de retro */
            getyears(props.user.id_budget, 'R')
            .then(async(years_retro) => {
                await setYearsRetro(years_retro);
    
                /* Récupération de la population par année */
                await axios.post("https://app-slfinance.fr/api/population.php", qs.stringify({
                    'get': true,
                    'id_organisme': props.user.id_organisme,
                    'annees': years_retro
                }))
                .then((res) => {
                    setObjet(res.data);
                })
                .catch((err) => {
                    console.warn(err);
                })
            })
        }
    }, [props.user]);


    // Resultat du formulaire
    const { register, handleSubmit } = useForm();
    
    const onSubmit = data => {
        var tmp = [];
        var i = 0;
        for (var elem in data) {
            tmp[i] = [elem, data[elem]];
            i++;
        }
        axios.post("https://app-slfinance.fr/api/population.php", qs.stringify({
            'update': true,
            'id_organisme': props.user.id_organisme,
            'objet': tmp
        }))
        .then((res) => {
            if (res.data['status'] === 1) {
                NotificationManager.success(res.data['status_message'], '', 500);
                setTimeout(() => window.location = window.location.href, 600);
            }
            else {
                NotificationManager.warning(res.data['status_message'], '', 3000);
            }
        })
        .catch((err) => {
            console.warn(err);
        })
    };

	return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex', margin: 25}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Population</p>
                </div>
                <div className='shadow-md' style={{textAlign: 'center',  borderRadius: 8, padding: 18, margin: 1, backgroundColor: 'white', boxShadow: '0 6px 18px rgba(0,0,0,0.04)'}}>
                    <div style={{marginBottom: 12}}>
                        <p style={{margin: 0, fontWeight: 600}}>Renseignez la population de votre collectivité</p>
                        <p style={{margin: 0, color: '#666', fontSize: 13}}>Saisissez la population pour chaque année listée ci-dessous.</p>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 12}}>
                            {YearsRetro && objet ?
                                objet.map(annee => (
                                    <div key={annee[0]} style={{padding: 12, border: '1px solid #F0F2F5', borderRadius: 8, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8}}>
                                            <div style={{fontWeight: 700}}>{annee[0]}</div>
                                            <div style={{fontSize: 12, color: '#888'}}>Personnes</div>
                                        </div>
                                        <input
                                            style={{width: '100%', border: '1px solid #E9ECEF', borderRadius: 6, padding: '10px 12px', fontSize: 14}}
                                            placeholder={annee[1]}
                                            {...register(annee[0])}
                                            disabled={!(props.user?.id_type_users == '1' || props.user?.id_type_users == '2')}
                                        />
                                    </div>
                                )) : null}
                        </div>

                        {(props.user?.id_type_users == '1' || props.user?.id_type_users == '2') &&
                        <div style={{marginTop: 22, display: 'flex', justifyContent: 'center'}}>
                            <button type="submit" style={{display: 'inline-flex', alignItems: 'center', gap: 8, backgroundColor: green, color: 'white', border: 'none', padding: '10px 16px', borderRadius: 8, cursor: 'pointer'}}>
                                <Check width="14" />
                                <span style={{fontWeight: 600}}>Valider</span>
                            </button>
                        </div>
                        }
                    </form>
                </div>
            </Access>
        </div>
	);
}

export default Population;
